





















import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import { Cycle } from '@/api/cycles';
import CycleSelect from '@/components/cycles/CycleSelect.vue';
import QualificationSummaryCard from '@/components/summary/QualificationSummaryCard.vue';
import RewardsSummaryCard from '@/components/summary/RewardsSummaryCard.vue';
import TunesSummaryCard from '@/components/summary/TunesSummaryCard.vue';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    CycleSelect,
    QualificationSummaryCard,
    RewardsSummaryCard,
    TunesSummaryCard,
  },
})
export default class QualificationsAndRewardsSummary extends Vue {
  fiId!: string;

  selectedCycle: Cycle | null = null;

  headerItems: any = [{
    text: 'Rewards Processing',
    disabled: false,
    link: false,
  },
  {
    text: 'Qualifications/Rewards Summary',
    disabled: true,
  }];

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
